module.exports = __webpack_public_path__ + "media/2022/est-1995-badge@2x-902b59a8.png";